import React from "react";
import "../css/members.scss";
import Team from "./Team";
import WaveTop from "./WaveTop";

const Goal = ({ goal }) => (
  <div className="goal-card">
    <img src={goal.image} alt={goal.title} className="goal-image" />
    <h3 className="goal-title">{goal.title}</h3>
    <p className="goal-description">{goal.description}</p>
  </div>
);

const AboutUs = ({ data }) => {
  if (!data || !data.board || !data.teachers || !data.goals) return null;

  const { title, text1, sectionTitle, goals } = data;

  return (
    <div className="members-page">
      <div className="members-content">
        <div className="members-content__inner">
          <div className="members-content__text">
            <h2>{title}</h2>
            <p>{text1}</p>
          </div>
          <img
            className="members-content__image"
            src="images/mongol.png"
            alt="zurag"
          />
        </div>
      </div>
      <WaveTop />
      <div className="members-goals">
        <h2>{sectionTitle}</h2>
        <div className="goals-grid">
          {goals.map((goal, index) => (
            <Goal key={index} goal={goal} />
          ))}
        </div>
      </div>

      <Team data={data} standalone={false} />
    </div>
  );
};

export default AboutUs;
